// Module
var code = "<svg viewBox=\"0 0 24 24\"> <path d=\"M15.798,13.456 L12,9.657 L8.202,13.456 L6,11.805 L6,16 L18,16 L18,11.805 L15.798,13.455 L15.798,13.456 Z M20,8 L20,16 C20,17.1045695 19.1045695,18 18,18 L6,18 C4.89588748,17.9988975 4.00110246,17.1041125 4,16 L4,8 L8,11 L12,7 L16,11 L20,8 Z\"></path> </svg>";
// Exports
module.exports = code;